module.exports = __webpack_public_path__ + "static/media/webdevelopment2.d9c6244d.png";